{"steps":{"initial":{},"tool-execution":{"ordinal":true,"parameters":{"tracePoint":{"type":"number"}}}},"frames":{}}